import { Expose, Type } from 'class-transformer';
import { RECEIVE_TIME_SC } from 'src/app/common/const';

export abstract class VehicleReport {

  id: number;

  @Expose({ name: RECEIVE_TIME_SC })
  @Type(() => Date)
  receiveTime: Date;

}
